interface Props {
  upcoming: number;
  completed: number;
  noShow: number;
  /** Optional sub-line for the primary KPI (e.g. "Next in 14 hr"). */
  upcomingSub?: string;
}

interface KpiProps {
  label: string;
  sub?: string;
  value: number;
  primary?: boolean;
}

function Kpi({ label, sub, value, primary }: KpiProps) {
  return (
    <div className={primary ? "zd-kpi primary" : "zd-kpi"}>
      <div>
        <div className="zd-kpi-label">{label}</div>
        {sub && <div className="zd-kpi-sub">{sub}</div>}
      </div>
      <div className="zd-kpi-num">{value}</div>
    </div>
  );
}

export function StatCards({ upcoming, completed, noShow, upcomingSub }: Props) {
  return (
    <div className="zd-kpis">
      <Kpi label="Upcoming" sub={upcomingSub} value={upcoming} primary />
      <Kpi label="Completed" sub={completed === 0 ? "No visits closed yet" : undefined} value={completed} />
      <Kpi label="No-shows" sub={noShow === 0 ? "Clear day so far" : undefined} value={noShow} />
    </div>
  );
}
